export const greaterThan = (limit: number) => {
  return (v: string) => {
    if (!v) return true

    return parseFloat(v) >= limit || `O campo deve ser maior ou igual a ${limit}`
  }
}
